export default __webpack_public_path__ + "static/eco-alliance-29b35d504287a9ea788fd8f43d9b3c63.svg";